import type { CustomizerStateType } from '../ducks/customizer/slice';

const STALE_KEYS = ['activeTheme'] as const;

const sanitizeCustomizerState = (raw: unknown): CustomizerStateType | undefined => {
  if (!raw || typeof raw !== 'object') return undefined;

  const next = { ...(raw as Record<string, unknown>) };
  for (const key of STALE_KEYS) {
    delete next[key];
  }

  return next as CustomizerStateType;
};

export const loadCustomizerState = () => {
  try {
    const serialized = localStorage.getItem('customizer');
    if (!serialized) return undefined;

    const parsed = sanitizeCustomizerState(JSON.parse(serialized));
    if (!parsed) return undefined;

    return { customizer: parsed };
  } catch (e) {
    console.warn('Failed to load state', e);
    return undefined;
  }
};

export const saveCustomizerState = (state: CustomizerStateType) => {
  try {
    const sanitized = sanitizeCustomizerState(state) ?? state;
    localStorage.setItem('customizer', JSON.stringify(sanitized));
  } catch (e) {
    console.warn('Failed to save customizer state', e);
  }
};
